import { FC } from 'react'
import s from './index.module.less'
import { THEME_COLOR } from '@/consts/theme'

interface LoadingProps {
  size?: number
  color?: string
}
const Loading: FC<LoadingProps> = (props) => {
  const { size = 24, color = THEME_COLOR  } = props
  return (
    <svg
      className={s.loadingIcon}
      viewBox="0 0 1024 1024"
      width={size}
      height={size}
    >
      <path
        d="M512 1024C229.034667 1024 0 794.965333 0 512S229.034667 0 512 0s512 229.034667 512 512-229.034667 512-512 512z m0-916.224C289.706667 107.776 107.776 289.706667 107.776 512c0 222.293333 181.888 404.224 404.224 404.224 222.293333 0 404.224-181.888 404.224-404.224 0-222.293333-181.888-404.224-404.224-404.224z"
        fill="#FFFFFF"
        fillOpacity=".3"
      />
      <path
        d="M970.112 565.888A54.058667 54.058667 0 0 1 916.224 512a403.029333 403.029333 0 0 0-115.882667-282.965333 56.234667 56.234667 0 0 1 0-76.8 56.234667 56.234667 0 0 1 76.8 0A514.517333 514.517333 0 0 1 1024 512c0 29.610667-24.234667 53.888-53.888 53.888z"
        fill={color}
      />
    </svg>
  )
}
export default Loading
